import React from 'react';
import { connectToUser } from '../../User/containers/UserDataStore';
import { connectToTitles } from '../containers/TitlesDataStore';
import { Button, Modal } from 'antd';
import { CSVLink } from 'react-csv';
import delay from '../../../util/delay';

export class TitleExportExcel extends React.Component {
	state = {
		titles: {},
		isActivated: false,
	};

	render() {
		const { isActivated } = this.state;

		return (
			<React.Fragment>
				<Button onClick={this.activate}>Excel</Button>
				<Modal
					title="Download Title CSV"
					visible={isActivated}
					onCancel={() => this.setState({ isActivated: false })}
					footer={null}>
					{isActivated && (
						<div>
							<span style={{ marginRight: '2rem' }}>
								<strong>Download Ready!</strong>
							</span>
							{this.renderCsvDownloader()}
						</div>
					)}
				</Modal>
			</React.Fragment>
		);
	}

	activate = () => {
		this.setState({ isLoading: true });

		return delay(750).then(() => {
			this.setState({ isActivated: true, isLoading: false });
		});
	};

	renderCsvDownloader() {
		const { titles } = this.props.titlesDataStore.state;
		return (
			<CSVLink
				filename="list.csv"
				headers={[
					'ISBN',
					'Title',
					'Author',
					'Imprint',
					'Format',
					'Pub Date',
					'Price',
					'Pages',
					'Dimensions',
					'Category',
				]}
				data={
					titles &&
					titles.map(title => {
						return [
							title.ean,
							title.name,
							title.author,
							title.supplier,
							title.format,
							this.formatDateValue(title.pubDate),
							title.prices &&
							title.prices.filter(pr => pr.name == 'USD').length >
								0
								? this.formatAsCurrency(
										title.prices.filter(
											pr => pr.name == 'USD',
										)[0].price,
								  )
								: '-',
							title.pages,
							title.measurements,
							title.category,
						];
					})
				}>
				<Button
					style={{ marginTop: '10px' }}
					icon="cloud-download"
					type="primary"
					onClick={this.deactivate}>
					Retrieve Prepared File
				</Button>
			</CSVLink>
		);
	}

	formatAsCurrency(number) {
		number = !number ? 0 : number;
		return number.toLocaleString('en-US', {
			style: 'currency',
			currency: 'USD',
		});
	}

	deactivate = () => {
		delay(200).then(() => this.setState({ isActivated: false }));
	};

	formatDateValue(value) {
		if (!value) return 'Invalid Date';
		return new Date(value).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		});
	}
}

export default connectToUser(connectToTitles(TitleExportExcel));
